module.exports = __webpack_public_path__ + "img/022-bathroom.9e09c828.svg";